import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyContainer = styled.div`
  background: #000000;
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(138, 138, 126, 0.08) 1px, transparent 1px),
    radial-gradient(circle at 75% 75%, rgba(138, 138, 126, 0.06) 1px, transparent 1px);
  background-size: 80px 80px, 120px 120px;
  min-height: 100vh;
  padding: 120px 0 80px;
  color: #ffffff;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(138, 138, 126, 0.4), transparent);
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    width: 300px;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(138, 138, 126, 0.3), transparent);
    z-index: 2;
  }
`;

const PrivacyContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 3;
`;

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  color: #b7ab9f;
  border: none;
  padding: 0.8rem 1rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 3rem;
  border-radius: 6px;

  &:hover {
    background: rgba(183, 171, 159, 0.1);
    transform: translateX(-4px);
  }

  &:before {
    content: '←';
    font-size: 1.2rem;
    font-weight: bold;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 3rem;
  color: #b7ab9f;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const ContentSection = styled.div`
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(183, 171, 159, 0.2);

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #b7ab9f;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const ContentText = styled.p`
  font-size: 1.1rem;
  line-height: 1.7;
  margin-bottom: 0;
  color: #cccccc;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;



const PrivacyPolicy = () => {
  const { language } = useLanguage();

  const goBack = () => {
    window.history.back();
  };

  return (
    <PrivacyContainer>
      <PrivacyContent>
        <BackButton onClick={goBack}>
          {language === 'fr' ? 'Retour' : 'Back'}
        </BackButton>

        <Title>
          {language === 'fr' ? 'Politique de confidentialité' : 'Privacy Policy'}
        </Title>

        <ContentSection>
          <SectionTitle>
            {language === 'fr' ? 'Protection de vos données' : 'Data Protection'}
          </SectionTitle>
          <ContentText>
            {language === 'fr' 
              ? 'Chez Groupe Garant, la protection de vos renseignements personnels est une priorité. Nous nous engageons à collecter, utiliser et conserver vos données conformément aux exigences de la Loi 25 sur la protection des renseignements personnels au Québec. Vos informations sont traitées de façon sécuritaire, confidentielle et uniquement pour les fins prévues. Vous disposez de droits d\'accès, de rectification et de retrait, que vous pouvez exercer en tout temps en nous contactant.'
              : 'At Groupe Garant, protecting your personal information is a priority. We are committed to collecting, using and storing your data in accordance with the requirements of Bill 25 on the protection of personal information in Quebec. Your information is processed securely, confidentially and only for the intended purposes. You have rights of access, rectification and withdrawal, which you can exercise at any time by contacting us.'
            }
          </ContentText>
        </ContentSection>

        <ContentSection>
          <SectionTitle>
            {language === 'fr' ? 'Conditions d\'utilisation' : 'Terms of Use'}
          </SectionTitle>
          <ContentText>
            {language === 'fr'
              ? 'En accédant et en utilisant ce site, vous acceptez de respecter nos conditions d\'utilisation. Vous vous engagez à ne pas diffuser de contenu illégal, diffamatoire ou nuisible. Nous nous réservons le droit de modifier ces termes à tout moment sans préavis. En utilisant ce site, vous acceptez également notre politique de confidentialité. Si vous n\'êtes pas d\'accord avec ces conditions, veuillez ne pas utiliser notre site.'
              : 'By accessing and using this site, you agree to respect our terms of use. You agree not to distribute illegal, defamatory or harmful content. We reserve the right to modify these terms at any time without notice. By using this site, you also accept our privacy policy. If you do not agree with these conditions, please do not use our site.'
            }
          </ContentText>
        </ContentSection>
      </PrivacyContent>
    </PrivacyContainer>
  );
};

export default PrivacyPolicy; 